<template>
	<v-card flat class="">
		<v-alert v-if="data.flag_end == '1'" dense shaped type="error">Non Aktif</v-alert>
		<judul-praktik :data="data"></judul-praktik>

		<v-card-title primary-title>
			<h4>Daftar Anggota</h4>
			<v-spacer></v-spacer>
			<v-dialog v-if="data.flag_end == '0'" v-model="dialog" max-width="800px">
				<template v-slot:activator="{ on, attrs }">
					<v-btn small color="primary" dark v-bind="attrs" v-on="on" @click="add()">
						Tambah
					</v-btn>
				</template>
				<v-card>
					<v-card-title>
						<span class="text-h6">{{ formTitle }}</span>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12">
								<v-select v-model="form.editedItem.role" outlined hide-details dense label="Role :"
									:items="form.roles" class="" @change="getUserBelumSelesai()"
									@keyup.enter="getUserBelumSelesai()"></v-select>
							</v-col>
							<v-col cols="12">
								<v-simple-table dense>
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left">
													No
												</th>
												<th class="text-left">
													Nama
												</th>
												<th class="text-left">
													Role
												</th>
												<th class="text-left">
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, key) in form.users" :key="item.name">
												<td>{{ (key + 1) }}</td>
												<td>{{ item.nama }}</td>
												<td>{{ item.role }}</td>
												<td>
													<v-checkbox v-model="form.editedItem.selectedUsers" x-small
														:value="item.id"></v-checkbox>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn color="primary" @click="save()">
							Simpan
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<router-link v-if="data.profesi == 'Dokter'"
				:to="{ name: 'AdminEvaluasiDokter', params: { praktik_id: data.id } }"
				style="text-decoration: none;">
				<v-btn block class="mx-2" small color="success" dark>Verifikasi</v-btn>
			</router-link>
			<router-link v-else-if="data.profesi == 'PPDS'"
				:to="{ name: 'AdminEvaluasiPPDS', params: { praktik_id: data.id } }"
				style="text-decoration: none;">
				<v-btn block class="mx-2" small color="success" dark>Verifikasi</v-btn>
			</router-link>
			<router-link v-else-if="data.profesi == 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain'"
				:to="{ name: 'AdminEvaluasiLain', params: { praktik_id: data.id } }"
				style="text-decoration: none;">
				<v-btn block class="mx-2" small color="success" dark>Verifikasi</v-btn>
			</router-link>
		</v-card-title>
		
		<v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
			:server-items-length="table.totalItems" :loading="table.loading" class="elevation-1">
			<template v-slot:item.stase="{ item }">
				{{ item.nama }}, {{ item.stase }}
			</template>
			<template v-slot:item.tanggal_awal="{ item }">
				{{ formatDate(item.tanggal_awal) }}
			</template>
			<template v-slot:item.tanggal_akhir="{ item }">
				{{ formatDate(item.tanggal_akhir) }}
			</template>
			<template v-if="data.flag_end == '0'" v-slot:item.actions="{ item }">
				<v-icon small @click="deleteItem(item)" title="Hapus" color="red">
					{{ icons.mdiDelete }}
				</v-icon>
			</template>
			<template v-slot:no-data>
				<v-btn small color="primary" @click="getDataFromApi()">
					Reload
				</v-btn>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import JudulPraktik from '@/components/JudulPraktik.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiDelete, mdiPencil } from '@mdi/js'

export default {
	components: {
		JudulPraktik,
	},
	data() {
		return {
			praktik_id: this.$route.params.id,
			data: {
				nama_institusi: '',
				nama_prodi: '',
				profesi: '',
				stase: '',
				tanggal_awal: '',
				tanggal_akhir: '',
			},
			icons: {
				mdiDelete,
				mdiPencil,
			},
			tableOptions: {},
			table: {
				loading: true,
				headers: [
					{
						text: 'No',
						align: 'start',
						sortable: false,
						value: 'no',
					},
					{
						text: 'Nama', value: 'nama', sortable: false
					},
					{
						text: 'Email', value: 'email', sortable: false
					},
					{
						text: 'Role', value: 'role', sortable: false
					},
					{ text: '', value: 'actions', sortable: false },
				],
				items: [],
				totalItems: 0,
			},
			dialog: false,
			form: {
				editedIndex: -1,
				editedItem: {
					role: '',
					selectedUsers: [],
				},
				defaultItem: {
					role: '',
					selectedUsers: [],
				},
				roles: [
					'PESERTA DIDIK', 'PEMBIMBING KLINIK'
				],
				users: [],
			},
		}
	},
	watch: {
		tableOptions: {
			handler() {
				this.getDataFromApi()
			},
			deep: true,
		},
	},
	computed: {
		formTitle() {
			return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
		},
	},
	created() {
		this.getDetail()
	},
	methods: {
		save() {
			if (this.form.editedIndex > -1) {
			} else {
				const fmData = new FormData()
				fmData.append('praktik_id', this.praktik_id)
				fmData.append('role', this.form.editedItem.role)
				fmData.append('users', this.form.editedItem.selectedUsers)
				axiosPostAuth('api/Praktik/addUserPraktik', fmData)
					.then(response => {
						if (response.code === 200) {
							this.getDataFromApi()
							this.dialog = false
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		},
		getDataFromApi() {
			const { page, itemsPerPage } = this.tableOptions
			const fmData = new FormData()
			fmData.append('praktik_id', this.praktik_id)
			fmData.append('page', page)
			fmData.append('itemsPerPage', itemsPerPage)
			fmData.append('search', '')
			axiosPostAuth('api/Praktik/getUserPraktik_datatable', fmData)
				.then(response => {
					this.table.items = response.data
					this.table.totalItems = response.total
					this.table.loading = false
				})
				.catch(error => {
					alert(error)
				})
		},
		add() {
			this.form.editedItem = Object.assign({}, this.form.defaultItem)
			this.form.editedIndex = -1
		},
		editItem(item) {
			this.form.editedIndex = this.table.items.indexOf(item)
			this.form.editedItem = Object.assign({}, item)
			this.dialog = true
		},
		// childMessageReceived(arg) {
		// 	console.log(arg);
		// 	this.dialogSelectUser = false
		// },
		getUserBelumSelesai() {
			const fmData = new FormData()
			fmData.append('praktik_id', this.praktik_id)
			fmData.append('profesi', this.data.profesi)
			fmData.append('id_institusi', this.data.id_institusi)
			fmData.append('id_prodi', this.data.id_prodi)
			fmData.append('role', this.form.editedItem.role)
			axiosPostAuth('api/Praktik/getUserBelumSelesai', fmData)
				.then(response => {
					this.form.users = response.data
					this.form.editedItem.selectedUsers = []
				})
				.catch(error => {
					alert(error)
				})
		},
		getDetail() {
			const fmData = new FormData()
			fmData.append('id', this.praktik_id)
			axiosPostAuth('api/Praktik/getPraktik', fmData)
				.then(response => {
					this.data = Object.assign({}, response.data)
					this.getUserBelumSelesai()
				})
				.catch(error => {
					alert(error)
				})
		},
		deleteItem(item) {
			const conf = confirm("Apakah yakin akan dihapus?")
			if (conf) {
				const fmData = new FormData()
				fmData.append('id', item.id)
				axiosPostAuth('api/Praktik/deleteUserPraktik', fmData)
					.then(response => {
						if (response.code === 200) {
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		},
	},
}
</script>